export const Pages = {
    directives: {},
    modules: {}
};
